/* DIBOR 07/10/2026 (speed, D-141 profile fixes 2 + 3): start Yotpo card stars and the collection Rebuy row only
   when they come near the screen. Same widgets, same data; only the timing changes.
   - Cards render `.dibor-yotpo-lazy` instead of `.yotpo-widget-instance`. Near the viewport the class is restored and
     Yotpo's initWidget(instanceId, element) renders that one instance (one ratings request each, tested 07/10).
   - The apps section with "Load when scrolled to" on renders Rebuy blocks with `data-dibor-rebuy-id`. Near the
     viewport the attribute is restored and one Rebuy Widget is started for that element only (3 requests, tested
     07/10); if Rebuy's internals are not reachable it falls back to Rebuy.reinit().
   If IntersectionObserver is missing everything is started at once, which is today's behaviour. */
(function () {
  var MARGIN = '600px 0px';

  function waitFor(test, cb, tries) {
    tries = tries || 0;
    if (test()) return cb();
    if (tries > 100) return; // ~20 s, then give up quietly (the page still works, just without the widget)
    setTimeout(function () { waitFor(test, cb, tries + 1); }, 200);
  }

  /* ---------- Yotpo stars ---------- */
  function startYotpo(el) {
    if (el.dataset.diborStarted) return;
    el.dataset.diborStarted = '1';
    el.className = 'yotpo-widget-instance';
    waitFor(function () { return window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidget; }, function () {
      if (el.getAttribute('data-yotpo-element-loaded') === 'true') return; // Yotpo's own observer got there first
      try {
        window.yotpoWidgetsContainer.initWidget(el.getAttribute('data-yotpo-instance-id'), el);
      } catch (e) {
        try { window.yotpoWidgetsContainer.initWidgets(); } catch (e2) {}
      }
    });
  }

  /* ---------- Rebuy row ---------- */
  function startRebuy(el) {
    if (el.dataset.diborStarted) return;
    el.dataset.diborStarted = '1';
    el.setAttribute('data-rebuy-id', el.getAttribute('data-dibor-rebuy-id'));
    el.removeAttribute('data-dibor-rebuy-id');
    /* 08/10/2026 (D-187 A5): Rebuy's own ready event starts the row as well as the 200 ms poll, whichever
       comes first; the poll stays for the case where the event fired before this script ran. */
    var started = false;
    function once() {
      if (started) return;
      started = true;
      document.removeEventListener('rebuy.ready', once);
      setTimeout(function () {
        if (el.getAttribute('data-initialized') === 'true') return; // Rebuy's first scan picked it up
        var W = window.Rebuy.widgets && window.Rebuy.widgets[0] && window.Rebuy.widgets[0].constructor;
        try {
          if (!W) throw new Error('no widget class');
          new W(el);
        } catch (e) {
          if (window.Rebuy.reinit) window.Rebuy.reinit();
        }
      }, 300);
    }
    document.addEventListener('rebuy.ready', once);
    waitFor(function () { return window.Rebuy && window.Rebuy.init; }, once);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      if (en.target.classList.contains('dibor-yotpo-lazy')) startYotpo(en.target);
      else startRebuy(en.target);
    });
  }, { rootMargin: MARGIN }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.dibor-yotpo-lazy:not([data-dibor-seen]), [data-dibor-rebuy-id]:not([data-dibor-seen])').forEach(function (el) {
      el.setAttribute('data-dibor-seen', '1');
      if (!io) return el.classList.contains('dibor-yotpo-lazy') ? startYotpo(el) : startRebuy(el);
      io.observe(el);
    });
  }

  scan();
  // Cards added later (filters, sort, pagination, recommendations) arrive through section re-renders.
  var queued = false;
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) {
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
